<template>
  <div class="internal short-page service">
    <div class="container">
      <h1>Services</h1>
      <hr />
      <p>
        At SEA Scaffolding we specialize in providing safe, reliable, and fully compliant scaffolding solutions for projects of all sizes. Whether you’re working on a small residential renovation, a large-scale commercial development, 
        or an industrial facility, our expert team is here to support you with top-quality scaffolding services.
        <br>
        <br> We offer a full range of scaffolding solutions, including:
      </p>

      <ul>
        <li><strong>Residential Scaffolding</strong> – Safe and secure scaffolding for home extensions, roof repairs, painting, and general maintenance.</li>
        <li><strong>Commercial Scaffolding</strong> – Reliable scaffolding for office buildings, retail spaces, and large-scale construction projects.</li>
        <li><strong>Industrial Scaffolding</strong> – Heavy-duty scaffolding designed for factories, power plants, and warehouses.</li>
        <li><strong>Access Scaffolding</strong> – Custom structures to provide safe access to difficult or high-reach areas.</li>
        <li><strong>Temporary Roof Scaffolding</strong> – Weatherproof covers to protect your project from the elements.</li>
        <li><strong>Suspended & Cantilever Scaffolding</strong> – Specialized solutions for projects where ground support is limited.</li>
        <li><strong>Shoring & Support Scaffolding</strong> – Strong and stable structures to reinforce buildings during construction or renovation.</li>
        <li><strong>Bespoke & Specialist Scaffolding</strong> – Tailored designs for unique projects, including heritage restoration and complex architectural builds.</li>
      </ul>

      <p>Safety is at the core of everything we do. We adhere to strict industry regulations and best practices, ensuring that every scaffold we install meets the highest standards. Our experienced team works closely with clients to minimise disruption and 
        offer practical, cost-effective solutions while maintaining a strong focus on safety and efficiency.
        <br>
        <br> From initial planning and design to installation, maintenance, and dismantling, we’re here to provide seamless scaffolding services from start to finish.
        <br>
        <br> Get in touch today to discuss your scaffolding requirements and see how we can help you build with confidence.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "services",
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Services.vue